import React from 'react';
import Navbar from '../components/Navbar/Component';
import CategoryTabs from '../components/CategoryTabs/Component';
// import CategoryView from '../components/CategoryView/Component';
import FilterBar from '../components/FilterBar/Component';
import PromoBanner from '../components/PromoBanner/Component';

function HomePage() {
  return (
    <>
  <Navbar/>
  <CategoryTabs/>
  {/* <CategoryView/> */}
  <FilterBar/>
  <PromoBanner/>
  
    </>
  )
}

export default HomePage
